'use client';

import { getPageLink } from '@/app/lib/contentful';
import { Text } from '@/components/text';
import { Body } from '@/components/text-layout/body';

import { Button } from '../button';

import { PrimaryButton } from './primary-button';
import { buttonLayout } from './style';

import type { TextLayoutProps } from './text-layout.types';

export const TextLayout = ({
  heading,
  body,
  headingAccent = 'fixedLeft',
  headingElement = 'h2',
  headingVariant = 'h2',
  bodyVariant = 'richText',
  primaryButton,
  secondaryButton,
  secondaryButtonVariant = 'secondary',
  buttonLayoutVariant = 'stackedLeft',
}: TextLayoutProps) => (
  <>
    <Text
      variant={headingVariant}
      as={headingElement}
      accent={headingAccent}
    >
      {heading}
    </Text>
    <Body
      body={body}
      bodyVariant={bodyVariant}
    />
    {primaryButton || secondaryButton ? (
      <div className={buttonLayout({ variant: buttonLayoutVariant })}>
        {primaryButton ? (
          <PrimaryButton
            title={primaryButton.title!}
            link={getPageLink(primaryButton)}
          />
        ) : null}
        {secondaryButton ? (
          <Button
            variant={secondaryButtonVariant}
            {...getPageLink(secondaryButton)}
          >
            {secondaryButton.title}
          </Button>
        ) : null}
      </div>
    ) : null}
  </>
);
